// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ceb051f7","453":"2a8d7ddc","455":"b2cc3518","977":"7b6d4916"}[chunkId] + ".chunk.js";
};